import { INSTANCE, INSTANCELIST } from './API.js'

export const getFixedDesignsForSelect = ({ queryKey }) => {
  const { category } = queryKey[1] || {}
  return new Promise((resolve, reject) => {
    INSTANCELIST({
      method: 'get',
      url: '/fixed-designs',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      params: {
        sort: JSON.stringify(['name.en', 'ASC']),
        range: JSON.stringify([0, 999]),
        filter: JSON.stringify(category ? { category } : {}),
      },
    })
      .then((res) => resolve(res.list))
      .catch(reject)
  })
}

export const getFixedDesigns = ({ queryKey }) =>
  new Promise((resolve, reject) => {
    const { sort, range, filter, tabFilter } = queryKey[1]
    INSTANCELIST({
      method: 'get',
      url: '/fixed-designs',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      params: {
        sort: JSON.stringify(sort),
        range: JSON.stringify(range),
        filter: JSON.stringify(filter),
        ...tabFilter,
      },
    })
      .then(resolve)
      .catch(reject)
  })

export const getFixedDesignById = ({ queryKey }) =>
  new Promise((resolve, reject) => {
    const { id } = queryKey[1]
    INSTANCE({
      method: 'get',
      url: `/fixed-designs/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then(resolve)
      .catch(reject)
  })

export const createFixedDesign = (form) =>
  new Promise((resolve, reject) => {
    INSTANCE({
      method: 'post',
      url: '/fixed-designs',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      data: form,
    })
      .then(resolve)
      .catch(reject)
  })

export const updateFixedDesign = (form, id) =>
  new Promise((resolve, reject) => {
    INSTANCE({
      method: 'put',
      url: `/fixed-designs/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      data: form,
    })
      .then(resolve)
      .catch(reject)
  })
